import combineReducers from './reducers/index'

export default combineReducers;


